export default __webpack_public_path__ + "static/media/General's Armguards of the Battlements.b746aa52.jpg";